<template>
  <div class="d-flex flex-column flex-grow-1">
    <BaseTopLine></BaseTopLine>
    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[430px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"> Наименование </label>
          <BaseInputNew
            @keyupEnter="getWithFilter()"
            inputClass="tw-app-input-dark"
            @input="filters.title.value = $event.value"
            :value="filters.title.value"
          />
        </div>
        <div class="tw-flex tw-flex-row">
          <button
            type="button"
            class="tw-app-btn-primary"
            @click="getWithFilter()"
          >
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter()">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px]">
      <div class="tw-my-[15px] tw-flex tw-items-center tw-gap-[10px]">
        <button
          class="tw-app-btn-primary"
          @click="$modal.show('AddPhonesToBook')"
        >
          <img
            :src="require(`@/assets/icons/addwhite.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Добавить
        </button>
        <button class="tw-app-btn-primary-outline" @click="setRemovePhone()">
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Удалить
        </button>
      </div>
    </div>

    <div class="tw-px-[26px]">
      <!-- <div class="tw-flex tw-justify-end tw-pb-[15px]">
        <TwBasePagination
          :page-count="bookPhonesData.total / bookPhonesData.limit"
          :pagination-params="{ ...bookPhonesData, limit: limit }"
          @updateLimitValue="(limit = $event), getData()"
          :page-range="10"
          :margin-pages="0"
          :click-handler="getWithFilter"
        >
        </TwBasePagination> 
      </div>-->
      <ve-table
        class="rest-style-table"
        style="width: 100%"
        :columns="columns"
        :table-data="bookPhonesDataFiltered.rows || []"
        :border-x="true"
        :border-y="true"
        row-key-field-name="book_contacts__id"
        :checkbox-option="{
          hideSelectAll: false,
          selectedRowChange: selectedRowChange,
          selectedAllChange: selectedAllChange,
        }"
        :clickHighlight="false"
        :eventCustomOption="eventCustomOption"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :cellSelectionOption="{ enable: false }"
      />
    </div>

    <BaseModal
      name="AddPhonesToBook"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="!tw-bg-transparent !tw-shadow-none"
      @before-close="resetNewPhone()"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('AddPhonesToBook')"
        ></button>

        <div>
          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Наименование</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="newPhone.book_contacts__name = $event.value"
              :value="newPhone.book_contacts__name"
            ></BaseInputNew>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Телефон</div>
            <BaseInputNew
              class="tw-mb-[15px]"
              inputClass="tw-app-input-type-3"
              @input="
                $event.value.length == 16
                  ? (newPhone.book_contacts__phone1 = $event.value)
                  : false
              "
              :value="newPhone.book_contacts__phone1"
              inputMask="+{7}(000)000-00-00"
              maxLength="16"
            />
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Описание</div>
            <BaseTextarea
              inputClass="tw-app-input-type-3"
              :resize="false"
              @onInput="newPhone.book_contacts__description = $event.value"
              :minHeight="'160'"
              :value="newPhone.book_contacts__description"
            >
            </BaseTextarea>
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('AddPhonesToBook')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="submit"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
              :disabled="submitting"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      name="RemovePhone"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('RemovePhone')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">Удалить запись?</div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('RemovePhone')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="removePhone()"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Выполнить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import GeneralService from "@/api/GeneralService";
import { VeTable } from "vue-easytable";
import dayjs from "dayjs";

export default {
  components: {
    VeTable,
  },
  data() {
    return {
      activeSelectRowsMultiple: [],
      bookPhonesData: {},
      bookPhonesDataFiltered: {},
      newPhone: {
        book_contacts__id: null,
        book_contacts__name: "",
        book_contacts__phone1: "",
        book_contacts__description: "",
      },
      submitting: false,
      filters: {
        title: {
          value: null,
        },
      },
      limit: 500,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.newPhone.book_contacts__id = row.book_contacts__id;
              this.newPhone.book_contacts__name = row.book_contacts__name;
              this.newPhone.book_contacts__phone1 = row.book_contacts__phone1;
              this.newPhone.book_contacts__description =
                row.book_contacts__description;
              console.log(row);
              setTimeout(() => this.$modal.show("AddPhonesToBook"), 10);
            },
          };
        },
      },
    };
  },
  created() {
    this.setBookPhonesRoute(this.$router.currentRoute.path);
    this.getData();
  },
  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
    columns() {
      return [
        {
          field: "",
          key: "a",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "book_contacts__name",
          key: "book_contacts__name",
          title: "Наименование",
          align: "center",
          width: "10%",
        },
        {
          field: "book_contacts__phone1",
          key: "book_contacts__phone1",
          title: "Телефон",
          align: "center",
          width: "10%",
        },
        {
          field: "book_contacts__description",
          key: "book_contacts__description",
          title: "Описание",
          align: "center",
          width: "40%",
        },
      ];
    },
  },

  methods: {
    resetFilter() {
      this.filters.title.value = null;
      this.getData();
    },
    setRemovePhone() {
      if (this.activeSelectRowsMultiple?.length) {
        this.$modal.show("RemovePhone");
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    removePhone() {
      GeneralService.delete(`/book-contacts/${this.activeSelectRowsMultiple}`)
        .then((data) => {
          this.$toast.success(data.data.message, { duration: 5000 });
          this.getData();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
      this.$modal.hide("RemovePhone");
    },
    resetNewPhone() {
      this.newPhone.book_contacts__id = null;
      this.newPhone.book_contacts__name = "";
      this.newPhone.book_contacts__phone1 = "";
      this.newPhone.book_contacts__description = "";
    },
    submit() {
      this.submitting = true;
      if (this.newPhone.book_contacts__id) {
        GeneralService.edit(
          `/book-contacts/${this.newPhone.book_contacts__id}`,
          this.newPhone
        )
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.hide("AddPhonesToBook");
            this.getData();
          })
          .finally(() => {
            this.submitting = false;
          });
      } else {
        GeneralService.editOrCreate(`/book-contacts`, this.newPhone)
          .then((data) => {
            this.resetNewPhone();
            this.$toast.success(data.data.message);
            this.$modal.hide("AddPhonesToBook");
            this.getData();
          })
          .finally(() => {
            this.submitting = false;
          });
      }
    },
    selectedRowChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    getData(where = [], page = 1) {
      GeneralService.get(`/book-contacts`, {
        params: {
          where: JSON.stringify(where),
          page: page,
          limit: this.limit,
        },
      })
        .then((data) => {
          this.bookPhonesData = structuredClone(data.data.data);
          this.bookPhonesDataFiltered = structuredClone(data.data.data);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    getWithFilter() {
      if (this.filters?.title?.value?.length) {
        this.bookPhonesDataFiltered.rows = this.bookPhonesData.rows.filter(
          (i) =>
            String(i.book_contacts__name)
              ?.toLowerCase()
              ?.includes(this.filters?.title?.value?.toLowerCase())
        );
      } else {
        this.bookPhonesDataFiltered.rows = this.bookPhonesData.rows;
      }
    },
    ...mapActions("bookPhonesModule", [
      "getBookPhonesAll",
      "createBookPhonesData",
      "editBookPhonesMultiple",
      "deleteBookPhonesData",
      "setBookPhonesRoute",
    ]),
  },
};
</script>
